export default __webpack_public_path__ + "static/media/live-feed-lock-open.f02daf26.svg";